import { FC, SVGProps } from 'react';

export const RefreshIcon: FC<SVGProps<SVGSVGElement>> = props => (
	<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none" {...props}>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M23.312 3.25263C23.7248 3.21802 24.0874 3.52458 24.1221 3.93734L24.6056 9.704C24.6231 9.91307 24.5523 10.1199 24.4103 10.2744C24.2682 10.4288 24.068 10.5167 23.8582 10.5167H18.0557C17.6415 10.5167 17.3057 10.1809 17.3057 9.76667C17.3057 9.35245 17.6415 9.01667 18.0557 9.01667H22.0647C20.3365 7.5515 18.0923 6.66668 15.638 6.66668C10.1706 6.66668 5.75 11.057 5.75 16.4583C5.75 21.8597 10.1706 26.25 15.638 26.25C20.3299 26.25 24.2538 23.0149 25.2698 18.6829C25.3644 18.2797 25.768 18.0294 26.1712 18.124C26.5745 18.2186 26.8248 18.6222 26.7302 19.0254C25.5567 24.0289 21.0331 27.75 15.638 27.75C9.35501 27.75 4.25 22.701 4.25 16.4583C4.25 10.2157 9.35501 5.16668 15.638 5.16668C18.4161 5.16668 20.9631 6.15369 22.9401 7.79328L22.6273 4.06268C22.5927 3.64992 22.8992 3.28725 23.312 3.25263Z"
			fill="currentColor"
		/>
	</svg>
);
